var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeroMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.9983,
    y: 0.737799,
    width: 32.8954,
    height: 32.8954,
    rx: 3.65192,
    transform: "rotate(45 23.9983 0.737799)",
    fill: "#9E9E9E",
    stroke: "#FDFFFD",
    strokeWidth: 1.04341
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8936 32.565C35.8234 30.7731 36.3679 28.8046 36.4899 26.7864C36.6202 24.6311 36.2654 22.4741 35.4517 20.474C34.638 18.474 33.386 16.682 31.788 15.2299C30.1899 13.7778 28.2866 12.7027 26.218 12.0836C24.1494 11.4645 21.9684 11.3173 19.8354 11.6527C17.7024 11.9882 15.6718 12.7978 13.8931 14.022C12.1144 15.2462 10.633 16.8537 9.55786 18.7262L14.0524 21.3068C14.7416 20.1065 15.6912 19.076 16.8314 18.2913C17.9716 17.5066 19.2733 16.9876 20.6406 16.7725C22.0079 16.5575 23.406 16.6518 24.732 17.0487C26.0581 17.4455 27.2782 18.1348 28.3025 19.0656C29.3269 19.9964 30.1295 21.1452 30.6511 22.4272C31.1727 23.7093 31.4002 25.092 31.3166 26.4736C31.2331 27.8552 30.8407 29.2005 30.1685 30.4104C29.7251 31.2082 29.1675 31.9338 28.5154 32.565H34.8936Z",
    fill: "url(#paint0_linear_1078_6220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1104 33.5299C26.3101 33.5299 29.7146 30.1254 29.7146 25.9258C29.7146 21.7261 26.3101 18.3217 22.1104 18.3217C17.9108 18.3217 14.5063 21.7261 14.5063 25.9258C14.5063 30.1254 17.9108 33.5299 22.1104 33.5299ZM18.141 31.0255C18.141 31.0255 18.1264 27.3994 19.7252 26.0289C20.6841 25.2069 21.7763 24.9815 22.8898 24.7516C24.0545 24.5112 25.2427 24.2659 26.3263 23.328C26.8132 22.9066 27.1891 22.2924 27.3345 22.0548C27.3553 22.0208 27.3714 21.9945 27.3824 21.9776C28.5088 23.7629 28.8522 28.3505 26.3263 30.6065C23.9344 32.7428 20.3627 32.243 18.141 31.0255Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1078_6220",
    x1: 31.3573,
    y1: 16.2459,
    x2: 13.0023,
    y2: 17.8605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroMe);
export default __webpack_public_path__ + "static/media/zeroMe.88b66eb065a6c5c9337bbfc057b1f8b7.svg";
export { ForwardRef as ReactComponent };